(function () {
    'use strict';

    a3_cabin_reports.directive('flightMealPanel', flightMealPanel);
    /**
    * @memberof CabinReports
    * @ngdoc directive
    * @name flightMealPanel
    * @restrict E
    * @description
    *   Implementation of flightMealPanel directive
    * @example
    *   Usage:
    *   <flight-meal-panel></flight-meal-panel>
    * @ngInject
    */
    function flightMealPanel($location, FlightMealCriteriaFactory) {
        function link(scope,  element, attributes) {
            scope.mealCriteria = null;
            scope.showPanel = null;
            scope.gotoMealLibrary = gotoMealLibrary;

            //navigates to meal library
            function gotoMealLibrary(mealClass, searchText) {
                $location.path('/mealLibrary/'+ scope.flightId + '/' + mealClass + '/' + searchText);
            }

            //get from LS the meal criteria for the flight
            if(scope.flightId)
                scope.mealCriteria = FlightMealCriteriaFactory.getMealCriteriaByFlightIdFromLS(scope.flightId);
        }

        return {
            restrict: 'E',
            terminal: false,
            templateUrl: 'views/FlightMealPanel/flightMealPanel.tpl.html',
            scope: false,
            link: link
        }
    }

})();
